<div class="d-flex align-items-end justify-content-end mb-5">
  <mat-form-field appearance="standard">
    <mat-select [placeholder]="'USER.INPUT.ROLE' | translate" [(ngModel)]="roleIdForAdding">
      <mat-option *ngFor="let role of unassignedRoles" [value]="role.id">{{
        role.title
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <button
    matTooltip="Assign Role"
    style="margin-bottom: 1.34375em"
    class="btn btn-sm btn-icon btn-light ml-2"
    (click)="assignRole()"
  >
    <i class="flaticon2-add-1 icon-nm"></i>
  </button>
</div>
<div class="pb-5">
  <div class="header-row">
    <div class="header-cell title">Title</div>
    <div class="header-cell actions">Actions</div>
  </div>
  <ng-container *ngIf="assignedRoles.length">
    <div *ngFor="let role of assignedRoles" class="body-row">
      <div class="body-cell title">{{ role.title }}</div>
      <div class="body-cell actions">
        <button
          matTooltip="Un-Assign Role"
          class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
          (click)="unAssignRole(role)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
            class="svg-icon svg-icon-md svg-icon-danger"
          ></span>
        </button>
      </div>
    </div>
  </ng-container>
  <div
    *ngIf="!assignedRoles.length"
    style="min-height: 100px"
    class="d-flex flex-center font-weight-bold"
  >
    There are no roles assigned!
  </div>
</div>
